import { render, staticRenderFns } from "./VideoInfoHero.vue?vue&type=template&id=c80ab5a6&scoped=true"
import script from "./VideoInfoHero.vue?vue&type=script&lang=js"
export * from "./VideoInfoHero.vue?vue&type=script&lang=js"
import style0 from "./VideoInfoHero.vue?vue&type=style&index=0&id=c80ab5a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80ab5a6",
  null
  
)

export default component.exports